import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { CardsApi, type ChangeCardNameRequest } from '@shared/api';

interface DisputeTransactionsType {
  loading: boolean;
  error: string | null;
  success: boolean;
  post: (request: ChangeCardNameRequest, signal?: AbortSignal) => Promise<void>;
  resetError: () => void;
  clear: () => void;
}

export const useDisputeTransactionsStore = create<DisputeTransactionsType>((set) => ({
  loading: false,
  error: null,
  success: false,

  post: ApiUtils.wrapperApi(async (request, signal) => {
    try {
      set({ loading: true, error: null, success: false });
      await CardsApi.postDisputeTransactions(request, signal);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false, success: false });
    }
  }, RequestStrategyEnum.Debounce),

  resetError: () => set({ error: null }),

  clear: () => set({ loading: false, error: null, success: false }),
}));
